import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

ReviewStepHeader.propTypes = {
	icon: PropTypes.string,
	label: PropTypes.string,
	isMobile: PropTypes.func,
};

function ReviewStepHeader({ label, isMobile, icon }) {
	const fontSize = isMobile() ? 24 : 32;
	return (
		<div className="review-step-header" style={{ marginBottom: '1.5rem' }}>
			<span style={{ color: '#fc601f', fontSize }}>
				<Icon type={icon} />{' '}
				<span style={{ marginLeft: 3 }}>{label}</span>
			</span>
		</div>
	);
}

export default withIsMobile(ReviewStepHeader);
